import { Link, useLocation } from 'react-router-dom';
import { Home, ArrowLeft } from 'lucide-react';

export default function NotFound() {
  const location = useLocation();

  return (
    <div className="min-h-screen relative bg-secondary-950 flex items-center justify-center overflow-hidden">
      {/* Animated gradient background */}
      <div
        aria-hidden="true"
        className="absolute inset-0 opacity-15 animate-gradient-shift"
        style={{
          backgroundImage:
            'radial-gradient(circle at 30% 40%, rgba(53,94,59,0.4) 0%, transparent 50%), radial-gradient(circle at 70% 60%, rgba(53,94,59,0.2) 0%, transparent 45%)',
          backgroundSize: '200% 200%',
        }}
      />

      <div className="relative text-center px-4 max-w-lg mx-auto">
        {/* Brand logo */}
        <div className="mb-6">
          <img
            src="/brand/logo-200.png"
            alt="Second Story"
            className="h-20 w-20 mx-auto rounded-full bg-white/95 p-1 shadow-lg"
          />
        </div>

        {/* 404 number */}
        <h1 className="font-display text-8xl sm:text-9xl font-bold text-primary-600/30 leading-none select-none">
          404
        </h1>

        <h2 className="text-2xl sm:text-3xl font-bold text-white mt-2 mb-3">
          Page Not Found
        </h2>

        <p className="text-secondary-400 mb-2 max-w-sm mx-auto">
          The page you're looking for doesn't exist or may still be under construction.
        </p>

        <p className="text-sm text-secondary-500 mb-8 font-mono">
          {location.pathname}
        </p>

        {/* Actions */}
        <div className="flex flex-col sm:flex-row gap-3 justify-center">
          <Link
            to="/"
            className="btn btn-lg bg-primary-600 text-white hover:bg-primary-500 inline-flex items-center justify-center shadow-md no-underline hover:no-underline"
          >
            <Home className="w-5 h-5 mr-2" />
            Back to Home
          </Link>

          <button
            onClick={() => window.history.back()}
            className="btn btn-lg border-2 border-white/30 text-white hover:bg-white/10 inline-flex items-center justify-center no-underline hover:no-underline"
          >
            <ArrowLeft className="w-5 h-5 mr-2" />
            Go Back
          </button>
        </div>

        {/* Helpful links */}
        <div className="mt-10 pt-8 border-t border-secondary-800">
          <p className="text-sm text-secondary-500 mb-4">Looking for something specific?</p>
          <div className="flex flex-wrap gap-3 justify-center">
            <Link to="/about" className="text-sm text-primary-400 hover:text-primary-300 no-underline hover:no-underline transition-colors">
              About Us
            </Link>
            <span className="text-secondary-700">·</span>
            <Link to="/login" className="text-sm text-primary-400 hover:text-primary-300 no-underline hover:no-underline transition-colors">
              Sign In
            </Link>
            <span className="text-secondary-700">·</span>
            <Link to="/register" className="text-sm text-primary-400 hover:text-primary-300 no-underline hover:no-underline transition-colors">
              Get Started
            </Link>
            <span className="text-secondary-700">·</span>
            <a
              href="mailto:eHunter@straydog-secondstory.org"
              className="text-sm text-primary-400 hover:text-primary-300 no-underline hover:no-underline transition-colors"
            >
              Contact Us
            </a>
          </div>
        </div>
      </div>
    </div>
  );
}